import React from 'react';
import LcLoading from '../../../components/Generic/LcLoading';
import LcNoData from '../../../components/Generic/LcNoData';
import ReactECharts from 'echarts-for-react';
import { Chart } from '../../endpointDetectionResponse/resumeEvent/Models';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { UserState } from '../../../store/reducers/userReducer';
import { SaasService } from '../../../services/saas/saasService';
import { useQuery } from 'react-query';
import { getOptionsDubleBarChart } from './EmailBoxesChart';

interface OneDriveUsageChartModel {
    userPeriod: number
}

const  OneDriveUsageChartData = (response: any): Chart => {
    if (response.data !== null) {
        let oneDriveUsageChart = {
            labels: response.data.map((Item: any) => {
                let date = new Date(Item.reportDate);
                return date.getDate().toString().padStart(2, '0') + "/" + (date.getMonth() + 1).toString().padStart(2, '0');
            }),
            datasets: [
                {
                    name: "Total de contas",
                    data: response.data.map((Item: any) => {
                        return Item.total
                    }),
                    type: 'bar',
                    barWidth: '40%',
                    barGap: '0%',
                    itemStyle: {
                        color: '#9fa3ff'
                    }
                },
                {
                    name: "Contas ativas",
                    data: response.data.map((Item: any) => {
                        return Item.active
                    }),
                    type: 'bar',
                    barWidth: '40%',
                    barGap: '0%',
                    itemStyle: {
                        color: '#471fcc'
                    }
                }
            ]
        };
        return oneDriveUsageChart;
    }else {
        let oneDriveUsageChart = {
            labels: [],
            datasets: []
        };
        return oneDriveUsageChart;
    }
}

export const OneDrveUsageChart: React.FC<OneDriveUsageChartModel> = ({userPeriod}) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const {data: chartData, isLoading } = useQuery({
        queryKey: ['oneDriveUsageChart', userPeriod, user.ClientGroupSelected, user.refreshFlag],
        refetchOnWindowFocus: false,
        staleTime: 2*(60*1000), 
        cacheTime: 5*(60*1000),
        queryFn: async () => {
            const saasService = new SaasService({});
            const response = await saasService.GetOneDriveUsageChart(userPeriod);
            const oneDriveUsageChart = OneDriveUsageChartData(response);
            return getOptionsDubleBarChart(oneDriveUsageChart);
        },
        onError: (error) => {
            console.error('Erro ao carregar dados do gráfico:', error);
        }
    })
    return (
        <LcLoading loading={isLoading}>
        {chartData && Object.keys(chartData).length > 0 ?
            <ReactECharts
                className="chart-medium"
                style={{ width: '100%', height: '100%' }}
                opts={{ renderer: 'svg', locale: 'PT-br' }}
                option={chartData}
            />
            :
            <LcNoData size="small" label="Sem dados no período." />
        }
    </LcLoading>
    );
}
